var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.phase == 0 || _vm.phase == 1)?_c('div',{staticClass:"holiday-savings-msg"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.msg['phase1'][_vm.text])}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }